"use client";

import RangeFilter from "@/components/ui/RangeFilter";
import { yearOptions } from "./_constants";
import { FC } from "react";
import { useTranslations } from "next-intl";

interface YearFilterProps {
  onFromYearChange: (value: { value: number; label: string } | null) => void;
  onToYearChange: (value: { value: number; label: string } | null) => void;
  onFromYearClear: () => void;
  onToYearClear: () => void;
  onReset: () => void;
  fromValue?: { value: number; label: string } | null;
  toValue?: { value: number; label: string } | null;
}

export const YearFilter: FC<YearFilterProps> = ({
  onFromYearChange,
  onToYearChange,
  onFromYearClear,
  onToYearClear,
  onReset,
  fromValue,
  toValue,
}) => {
  const t = useTranslations("Filters");

  return (
    <RangeFilter
      onFromChange={onFromYearChange}
      onToChange={onToYearChange}
      options={yearOptions}
      label={t("year")}
      onFromClear={onFromYearClear}
      onToClear={onToYearClear}
      onReset={onReset}
      fromValue={fromValue}
      toValue={toValue}
      skipFormatting
      allowSameValue={true}
    />
  );
};
